// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Container_wrapper__2hQ6I"};